import {
  Component, Input, Output, EventEmitter, ElementRef, ContentChildren,
  QueryList, ChangeDetectorRef, ViewChild,
} from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'scorecard-item',
  templateUrl: 'scorecard-item.component.html',
  styleUrls: ['scorecard-item.component.scss'],
})
export class ScorecardItemComponent {
  @Input() valid: number|boolean; // 1|0 indicate valid or invalid
  @Input() populated: number|boolean; // 1|0 indicate has valie or not
  @Input() path: string; // path to field
  @Input() fieldMap: string;
  @Input() collapsible: boolean = true; // can collapse content or not
  @Input() headerTitle: string;
  @Input() score: number; // Total number of valid fields
  @Input() possible: number; // Total number of fields
  @Input() headerBold: boolean; // bolds header title
  @Input() headerTooltip: boolean = false; // adds tooltip to the header
  @Input() name: string; // any arbitrary name for identifying item
  @Input() badgeNumber: number;
  @Input() badgeColor: string = 'darkred';

  @Output() detailsExpanded: EventEmitter<any> = new EventEmitter();
  @Output() detailsCollapsed: EventEmitter<any> = new EventEmitter();
  @Output() headerHovered: EventEmitter<any> = new EventEmitter();
  @Output() headerBlured: EventEmitter<any> = new EventEmitter();

  @ContentChildren('scorecardChildItem')
  scorecardChildItems: QueryList<ScorecardItemComponent>;

  @ViewChild('scorecardItem', {static: false}) scorecardItem: ElementRef | void;

  collapsed: boolean = true;

  /*******************************************
  * COMPONENT GETTERS
  *******************************************/

  get nativeEl(): any {
    return this.scorecardItem && this.scorecardItem.nativeElement;
  }

  get offsetTop(): number {
    return this.nativeEl.offsetTop;
  }

  get offsetHeight(): number {
    return this.nativeEl.offsetHeight;
  }

  constructor(
    private ref: ElementRef,
    private chRef: ChangeDetectorRef,
  ) {}

  /*******************************************
  * COMPONENT HANDLERS
  *******************************************/

  onHeaderClick() {
    this.collapsed = !this.collapsed;
    this.chRef.markForCheck();
    if (!this.collapsed) {
      this.detailsExpanded.emit({path: this.path, fieldMap: this.fieldMap});
    } else {
      this.detailsCollapsed.emit({path: this.path, fieldMap: this.fieldMap});
    }
  }

  onHeaderMouseenter() {
    this.headerHovered.emit(this.fieldMap);
  }

  onHeaderMouseleave() {
    this.headerBlured.emit(this.fieldMap);
  }

  /*******************************************
  * COMPONENT PUBLIC API
  *******************************************/

  collapseDetails(collapse: boolean): void {
    this.collapsed = collapse;
    this.chRef.markForCheck();
  }
}
